/** The stack.je mark: three stacked layers on the brand orange. */
export function BrandMark({ size = 28 }: { size?: number }) {
  return (
    <svg className="bw-mark" width={size} height={size} viewBox="0 0 28 28" role="img" aria-label="StackJe">
      <rect width="28" height="28" rx="7" fill="#dd5304" />
      <path d="M14 15.2 22 18.6 14 22 6 18.6Z" fill="#fff" opacity=".35" />
      <path d="M14 10.6 22 14 14 17.4 6 14Z" fill="#f7b58a" />
      <path d="M14 6 22 9.4 14 12.8 6 9.4Z" fill="#fff" />
    </svg>
  );
}
